import React, { ReactElement } from 'react'
import { Text } from '@chakra-ui/react'
import { useColor } from '../../../theme'
import { TTableCell } from '../types'

export const defaultTextCell: (
  isSecondaryText?: boolean,
) => TTableCell<string> =
  (isSecondaryText) =>
  (message): ReactElement => {
    const mainColor = useColor({ nuance: 5, palette: 'text' })
    const secondaryColor = useColor({ nuance: 2, palette: 'text' })

    return (
      <Text
        color={isSecondaryText ? secondaryColor : mainColor}
        fontSize={isSecondaryText ? 'sm' : 'auto'}
        letterSpacing={isSecondaryText ? '0.02em' : 'auto'}>
        {message}
      </Text>
    )
  }
